
import { defineComponent } from 'vue'
import recherchevehicule from "@/services/recherche_page.services"

export default defineComponent({
  name: 'resetActiveFilter',
  props: {
    name: String
  },
  setup: () => {
    const {
      resetFilter
    } = recherchevehicule;
    return {
      resetFilter
    }
  }
})
